import Vue from 'vue';
import * as MUTATIONS from '@/store/constants/mutations.js';
import { clobber } from 'commons/vuex/map/map.js';
import { formatUser } from './state.js';

export const mutations = {
    [MUTATIONS.SET_USER](state, { uuid, user }) {
        if (state.users[uuid]) {
            clobber(state.users[uuid], user);
        }
        else {
            Vue.set(state.users, uuid, formatUser(user));
        }
    },

    [MUTATIONS.SET_CURRENT_USER](state, current_user) {
        state.current = current_user.uuid;
        Vue.set(state.users, current_user.uuid, formatUser(current_user));
    },
};
